import { render, staticRenderFns } from "./IncidentsCard.vue?vue&type=template&id=00551b48&scoped=true"
import script from "./IncidentsCard.vue?vue&type=script&lang=js"
export * from "./IncidentsCard.vue?vue&type=script&lang=js"
import style0 from "./IncidentsCard.vue?vue&type=style&index=0&id=00551b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00551b48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
